import { useState, useEffect } from 'react'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler } from "chart.js";
import toast from 'react-hot-toast'
import { Spinner } from 'reactstrap';
import moment from 'moment';
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ChartDataLabels, RadialLinearScale, PointElement, LineElement, Filler);


import { getToken } from '../../../../utility/AuthService';
import { filterProgressAverageDataService, getProgressAverageDataService } from '../../../../services/analyticsServices/advanceAnalyticsService/advanceAnalyticsService';
import { demographicsListService } from '../../../../services/demographicsService';
import { getAllIndustryListService } from '../../../../services/industryService';
import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker';
import Selection from '../../Selection/Selection';
import RadarChart from '../../CustomChart/RadarChart';
import VerticalBarChart from '../../CustomChart/VerticalBarChart';
import { useForm } from 'react-hook-form';

const AvgClimateActionMaturity = (props) => {
    const token = getToken()
    const [isLoading, setLoading] = useState(false)
    const [countryName, setCountryName] = useState()
    const [stateName, setStateName] = useState()
    const [industryName, setIndustryName] = useState()
    const [companySizeName, setCompanySizeName] = useState()
    const [allIndustryList, setAllIndustryList] = useState([])
    const [avgPercentData, setAvgPercentData] = useState()
    const [allLabels, setAllLabels] = useState()
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);

    const {
        register,
        reset,
        handleSubmit,
        watch,
        control,
        formState: { errors },
        setValue
    } = useForm();

    const watchCountry = watch("Country")
    const watchState = watch("State")

    const companySizeList = [
        {
            value: "Less than RM 300,000",
            label: "Less than RM 300,000"
        },
        {
            value: "RM 300,000 - 3 mil",
            label: "RM 300,000 - 3 mil"
        },
        {
            value: "RM 3 mil - 20 mil",
            label: "RM 3 mil - 20 mil"
        },
        {
            value: "RM 20 mil - 50 mil",
            label: "RM 20 mil - 50 mil"
        },
        {
            value: "RM 50 mil - 100 mil",
            label: "RM 50 mil - 100 mil"
        },
        {
            value: "RM 100 mil +",
            label: "RM 100 mil +"
        }
    ]

    /**
        * @function getCountryList
        * @param
        * @description get country list using api
    */
    const getCountryList = async () => {
        try {
            const result = await demographicsListService({
                type: 'Country',
                typeId: ""
            });
            if (result?.data?.statusCode === 200) {
                setCountryList(result?.data?.data?.list?.map(item => {
                    return {
                        value: item?._id,
                        label: item?.name
                    }
                }))
            }
        } catch (error) {
            setCountryList([])
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    };

    /**
        * @function getStateList
        * @param
        * @description get state list using api
    */
    const getStateList = async () => {
        try {
            const result = await demographicsListService({
                type: 'State',
                typeId: watchCountry?.value
            });
            if (result?.data?.statusCode === 200) {
                setStateList(result?.data?.data?.list?.map(item => {
                    return {
                        value: item?._id,
                        label: item?.name
                    }
                }))
            }
        } catch (error) {
            setStateList([])
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    };

    useEffect(() => {
        getCountryList()
    }, []);

    useEffect(() => {
        setStateName()
        setValue("State", null)
        if (watchCountry?.value) {
            getStateList()
        }
    }, [watchCountry]);

    /**
        * @function fetchIndustryData
        * @param
        * @description to get all indistry list
    */
    const fetchIndustryData = async () => {
        try {
            const result = await getAllIndustryListService({
                token,
            });
            if (result?.data?.statusCode === 200) {
                setLoading(false)
                setAllIndustryList(result?.data?.data?.list?.map((item) => {
                    return {
                        value: item?._id,
                        label: item?.name
                    }
                }))
            } else {
                setLoading(false)
                setAllIndustryList([])
                toast.error(result?.response?.data?.message || 'Something went wrong')
            }

        } catch (error) {
            setLoading(false)
            setAllIndustryList([])
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    }

    /**
        * @function getProgressAverageData
        * @param ()
        * @description to get chart data
    */
    const getProgressAverageData = async () => {
        try {
            setLoading(true)
            const result = await getProgressAverageDataService({
                token
            });
            if (result?.data?.statusCode === 200) {
                setAllLabels(Object.keys(result?.data?.data?.averagePercent))
                setAvgPercentData(Object.values(result?.data?.data?.averagePercent)?.map(item => item?.toFixed(2)))
                setLoading(false)
            } else {
                setLoading(false)
                setAllLabels()
                setAvgPercentData()
                toast.error(result?.response?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            setLoading(false)
            setAllLabels()
            setAvgPercentData()
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    }

    useEffect(() => {
        fetchIndustryData()
    }, []);

    /**
        * @function filterProgressAverageData
        * @param
        * @description to get filter data
    */
    const filterProgressAverageData = async () => {
        try {
            setLoading(true)
            const result = await filterProgressAverageDataService({
                token,
                country: watchCountry?.label || '',
                state: watchState?.label || '',
                industry: industryName?.value || '',
                companySize: companySizeName?.value || '',
                fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
                toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
            });
            if (result?.data?.statusCode === 200) {
                setAllLabels(Object.keys(result?.data?.data?.averagePercent))
                setAvgPercentData(Object.values(result?.data?.data?.averagePercent)?.map(item => item?.toFixed(2)))
                setLoading(false)
            } else {
                setLoading(false)
                setAllLabels()
                setAvgPercentData()
                toast.error(result?.response?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            setLoading(false)
            setAllLabels()
            setAvgPercentData()
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    }

    useEffect(() => {
        if (watchCountry || watchState || industryName || companySizeName || startDate || endDate) {
            filterProgressAverageData()
        } else {
            getProgressAverageData()
        }
    }, [watchCountry, watchState, industryName, companySizeName, startDate, endDate]);

    useEffect(() => {
        setCountryName()
        setStateName()
        setIndustryName()
        setCompanySizeName()
        setStartDate()
        setEndDate()
    }, [props?.type]);

    const labelList = ["Climate Action Readiness", "Climate Governance", "GHG Emission Reduction", "Business strategy integration"]

    const VarticalBarData = {
        labels: labelList?.map(item => item?.split(" ")),
        datasets: [
            {
                data: avgPercentData,
                backgroundColor: ["#000", '#38761D', '#F1C232', '#00F'],
                hoverBackgroundColor: ["#000", '#38761D', '#F1C232', '#00F'],
                borderRadius: 5
            }
        ]
    };

    const VarticalBarOption = {
        responsive: true,
        scales: {
            x: {
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
            },
            y: {
                max: 100,
                ticks: {
                    display: false,
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                title: {
                    display: true,
                    text: 'Average Score'
                },
            },
            xAxes: [
                {
                    scaleLabel: {
                        display: false
                    },
                    gridLines: {
                        display: false
                    },
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        display: false,
                    },
                }
            ]
        },

        plugins: {
            legend: {
                display: false,
            },

            datalabels: {
                anchor: 'end',
                // clamp: false,
                align: 'start',
                color: "white",
                display: function (context) {
                    return context.dataset.data[context.dataIndex] > 0;
                },
                font: {
                    weight: "bold",
                },
                formatter: (value) => {
                    return `${parseFloat(value).toFixed(2)}%`
                },
            },
        },

        pointLabelFontFamily: "Quadon Extra Bold",
        scaleFontFamily: "Quadon Extra Bold",
    };

    const radarData = {
        labels: allLabels?.map(item => item?.split(" ")),
        datasets: [
            {
                label: 'Radar Chart',
                data: avgPercentData,
                backgroundColor: 'transparent',
                borderColor: '#009EDB',
                borderWidth: 3,
                pointRadius: 0,
                lineTension: 0.5
            }
        ],
    };

    const radarOptions = {
        plugins: {
            legend: {
                display: false
            },
            datalabels: {
                formatter: (value) => {
                    return parseInt(value)
                },
            }
        },
        scales: {
            r: {
                angleLines: {
                    display: true
                },
                suggestedMin: 0,
                suggestedMax: 100,
                grid: {
                    circular: true
                },
                ticks: {
                    beginAtZero: true,
                    max: 100,
                    min: 0,
                    stepSize: 25
                },
                pointLabels: {
                    font: {
                        size: 12,
                        // family: 'bold'
                    }
                }
            },

            borderRadius: 55
        }
    };

    return (
        <div className='bg-white px-2 mt-3'>
            <h3 className='mt-1 px-2'><strong>Average Climate Action Maturity Scores Across Companies</strong></h3>
            <div className='px-2 py-1'>
                <div className='d-flex flex-md-wrap flex-column flex-md-row justify-content-between align-items-center'>
                    <div className=''>
                        <Selection className={'w-100'} options={countryList} control={control} title={'Country'} name={'Country'} setWatchValue={setCountryName} styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                width: '250px'
                            }),
                        }} />
                    </div>
                    {watchCountry?.value &&
                        <div className=''>
                            <Selection className={'w-100'} options={stateList} title={'State'} control={control} name={'State'} setWatchValue={setStateName} styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '250px'
                                }),
                            }} />
                        </div>
                    }
                    <div className=''>
                        <Selection className={'w-100'} options={allIndustryList} title={'Industry'} name={'Industry'} setWatchValue={setIndustryName} styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                width: '250px'
                            }),
                        }} />
                    </div>
                    <div className=''>
                        <Selection className={'w-100'} options={companySizeList} title={'Company Size'} name={'CompanySize'} setWatchValue={setCompanySizeName} styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                width: '250px'
                            }),
                        }} />
                    </div>

                    <div className='d-flex flex-column flex-md-row align-items-center'>
                        <div className='me-2 mb-2 mb-md-0'>
                            <CustomDatePicker startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <div className='text-center h-100'><Spinner></Spinner></div>}
            {!isLoading && <>
                <div className='row container d-flex align-items-center mb-3'>
                    <div className='col-12 col-md-6'>
                        <VerticalBarChart data={VarticalBarData} options={VarticalBarOption} />
                    </div>
                    <div className='mb-3 p-1 col-12 col-md-6' style={{ height: '430px', width: '430px' }}>
                        <RadarChart data={radarData} options={radarOptions} />
                    </div>
                </div>
            </>}
        </div>
    )
};

export default AvgClimateActionMaturity